/* eslint-disable @typescript-eslint/naming-convention */
export enum TableStatusClasses {
  'Quote Approved' = 'approved',
  'Not Submitted' = 'notSubmitted',
  'In Pricing Review' = 'inReview',
  'Quote Expired' = 'expired',
  'Quote Requested' = 'requested'
}
